export const ENDPOINTS = {
  WORKSPACE_LIST: '/workspace/list',
  COURSE_LIST: (organisationId: number) =>
    `/client/course/list?organisationId=${organisationId}`,
  COURSE_LEVELS: (courseId: number) => `/client/course/${courseId}/levels`,
  LEVEL_QUESTIONS: (courseId: number, levelId: number) =>
    `/client/course/${courseId}/levels/${levelId}/questions`,
  SAVE_PROGRESS: (courseId: number, levelId: number) =>
    `/client/course/${courseId}/levels/${levelId}/progress`,
  LEADERBOARD: (range: string, organisationId: number) =>
    `/client/leaderboard?range=${range}&organisationId=${organisationId}`,
  TEST_ACCESS: (organisationId: number) =>
    `/client/test/access?organisationId=${organisationId}`,
  TEST_START: '/client/test/start',
  TEST_COMPLETE: (sessionId: number) => `/client/test/${sessionId}/complete`,
  NOTIFICATION_UNREAD_COUNT: '/client/notification/unread-count',
  NOTIFICATION_LIST: (organisationId: number, page: number) =>
    `/client/notification?organisationId=${organisationId}&page=${page}`,
  NOTIFICATION_MARK_READ: (id: number) => `/client/notification/${id}/read`,
};
